export const listCopyDe = {
    published: "Veröffentlicht",
    draft: "Entwurf",
    name: "Name",
    role: "Rolle",
    organisation: "Organisation",
    email: "E-Mail",
    dateOfBirth: "Geburtsdatum",
    labels: "Labels",
    status: "Status",
    actions: "Aktionen",
};
